import CustomButton from "components/button";
import dayjs from "dayjs";
import { Chain, CustomerTransactionStatus, Token, TransactionInterface } from "interfaces";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api, ui, utils } from "services";
import walletConnect from "services/wallet-connect";

export const ActionComponent = ({ data, trigger, setTrigger }: any) => {
    let is_claimed = data[TransactionInterface.is_claim];
    let claim_at = data[TransactionInterface.claim_at]
    let status = data[TransactionInterface.status] ?? 0;
    let lockTime = data[TransactionInterface.lock_processing]
    let can_claimed = !is_claimed && dayjs().isAfter(dayjs(claim_at))
        && [CustomerTransactionStatus.Pending, CustomerTransactionStatus.Processing].includes(status)
        && !(lockTime && dayjs(lockTime).isAfter(dayjs()))

    let [loading, setLoading] = useState(null);
    const { t } = useTranslation();

    const signTransaction = async (transactionInfo: any) => {
        try {
            try {
                walletConnect.preventWalletConnect();
            } catch (err) {
                return;
            }
            await api.checkTrueWallet(utils.getLoginTypeFromChain(transactionInfo[TransactionInterface.chain]), transactionInfo[TransactionInterface.wallet_address]);
            let token = transactionInfo[TransactionInterface.token_type] ?? Token.MAG
            let id = transactionInfo[TransactionInterface.id]
            let { message, signature } = await api.getUnstakeSignature(id);
            await api.requestWithdraw(Number(token), message.amount, message.nonce, message.timestamp, signature, data[TransactionInterface.chain] ?? Chain.BSC);
            ui.alertSuccess("Claim transaction success", `Please wait about 5~10 minutes to update your ${Token[token]} balance`)
        } catch (err: any) {
            ui.alertFailed(t(err.message?.message ?? err.message ?? err), "");
        } finally {
            setTrigger(!trigger)
            setLoading(null);
        }
    }

    return (
        <div className="flex justify-between gap-4">
            <CustomButton
                className="min-w-[60px]"
                disabled={!can_claimed}
                color={status === CustomerTransactionStatus.Claimed ? "gray" : "blue"}
                loading={data[TransactionInterface.id] === loading}
                onClick={async () => {
                    setLoading(data[TransactionInterface.id]);
                    await signTransaction(data)
                    setLoading(null);
                }}
            >
                {status === CustomerTransactionStatus.Claimed ? "Claimed" : "Claim"}
            </CustomButton>
        </div >
    )
}